<div class="negocio-prioridade-select dropdown">
    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">
        <ng-template [ngIf]="prioridade">
            <span>
                <i class="fas fa-flag" [style.color]="prioridade.cor"></i>
                {{prioridade.nome}}
            </span>
        </ng-template>

        <ng-template [ngIf]="!prioridade">
            <span>
                Nenhuma Prioridade
            </span>
        </ng-template>        
    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    [class.dropdown-item-select]="!idPrioridade"
                    (click)="select(null)">
                    Nenhuma Prioridade
                </a>
                <a *ngFor="let prior of prioridades" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="prior.id == idPrioridade"
                    (click)="select(prior)">
                    <i class="fas fa-flag" [style.color]="prior.cor"></i>
                    {{prior.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>